import React, { useState, useRef, useEffect } from 'react';
import useOnScreen from '../../hooks/useOnScreen';
import { Link } from 'react-router-dom';

function Producto({ data, index = 0 }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if (isVisible && !show) setShow(true);
  }, [isVisible]);

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(index % 4) * 70}ms` }}
      className={`group transition-all duration-700 ease-out ${
        show ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
    >
      <Link to={`/producto/${data.codigo}`} className="block">
        <div className="relative overflow-hidden rounded-2xl bg-ink-50">
          <div className="aspect-square w-full">
            <img
              src={require(`../../assets/images/productos/${data.codigo}/0.jpg`)}
              alt={`${data.codigo} ${data.nombre}`}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </div>

          {/* Hover overlay */}
          <div className="absolute inset-0 flex items-end justify-center bg-gradient-to-t from-ink/70 via-ink/5 to-transparent p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-white py-2.5 text-sm font-medium text-ink shadow-soft transition-colors hover:bg-brand-400">
              Ver más
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </div>

          {/* Code chip */}
          <span className="absolute left-3 top-3 rounded-full bg-white/85 px-3 py-1 text-xs font-medium text-ink backdrop-blur-sm">
            {data.codigo}
          </span>
        </div>

        <div className="px-1 py-3">
          <p className="text-sm font-light text-ink transition-colors group-hover:text-brand-600">
            {data.nombre}
          </p>
        </div>
      </Link>
    </div>
  );
}

export default Producto;
